import MetricCard from "components/MetricCard";
import MetricCardGroup from "components/MetricCard/Group";

import { formatMinutes } from "../../utils";
import styles from "./styles.module.css";

type RunMinutesTotalsViewProps = {
  privateMinutes: number;
  publicMinutes: number;
};

const RunMinutesTotalsView = ({ privateMinutes, publicMinutes }: RunMinutesTotalsViewProps) => (
  <MetricCardGroup padding="0" gap="x-large">
    <MetricCard
      containerClassName={styles.metricCard}
      titleColor="primary"
      title="Private worker minutes"
      value={formatMinutes(privateMinutes)}
    />
    <MetricCard
      containerClassName={styles.metricCard}
      titleColor="primary"
      title="Public worker minutes"
      value={formatMinutes(publicMinutes)}
    />
  </MetricCardGroup>
);

RunMinutesTotalsView.displayName = "UsageRunMinutes.Totals.View";

export default RunMinutesTotalsView;
